import { render, staticRenderFns } from "./goAbroad.vue?vue&type=template&id=59c4a436&scoped=true&"
import script from "./goAbroad.vue?vue&type=script&lang=js&"
export * from "./goAbroad.vue?vue&type=script&lang=js&"
import style0 from "./goAbroad.vue?vue&type=style&index=0&id=59c4a436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4a436",
  null
  
)

export default component.exports